<!-- ADD CUSTOMER COMPONENT -->
<form [formGroup]="captureClientDetailsForm" class="add-customer">

  <!-- <div class="tab-grid m-t-20">
    <nz-radio-group [(ngModel)]="currentLanguage" [ngModelOptions]="{standalone: true}" [nzButtonStyle]="'solid'"
      [nzSize]="'small'">
      <label nz-radio-button nzValue="EN">
        EN
      </label>
      <label nz-radio-button nzValue="TH">
        TH
      </label>
    </nz-radio-group>
  </div> -->

  <!-- NOTE: Use currentLanguage in ngModel -->
  <div class="grid grid-gap-20 grid-4x m-t-20">

    <!-- <nz-form-item>
      <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('clientTypeCd')"><span translate>{{genericSearchLabel.existingCustomer[currentLanguage]}}</span>
      </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-select nzShowSearch style="width: 100%" formControlName="existingCustomer">
          <nz-option nzLabel="Yes" nzValue = "YES"></nz-option>
          <nz-option nzLabel="No" nzValue = "NO"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item> -->

    <nz-form-item>
      <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('clientTypeCd')"><span
          translate>{{genericSearchLabel.clientType[currentLanguage]}}</span>
      </nz-form-label>
      <nz-select id="clientTypeCd" formControlName="clientTypeCd" style="width: 100%">
        <nz-option *ngFor="let item of (lookup$['clientTypeCd'] | async) as occupationCd; trackBy:item?.lookupKey"
          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
      </nz-select>
    </nz-form-item>
  </div>

  <div class="grid grid-gap-20 grid-4x">
    <ng-container *ngIf="captureClientDetailsForm && captureClientDetailsForm.get('clientTypeCd').value == 'PERSON'">
      <!-- title,firstName, middleName, lastName, gender, dateOfBirth, 
            nationality, countryOfBirthCd, maritalStatusCd, relationCd, occupationCd, educationTypeCd -->
      <!-- title -->
      <!-- <div class="flexie-auto-grid">
        <nz-form-item>
          <nz-form-label nzFor="title" [nzSpan]="24" [nzRequired]="isRequired('title')"><span translate></span>Title</span>
          </nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select id="title" formControlName="title" style="width: 200px;">
              <nz-option *ngFor="let item of (lookup$['titleCd'] | async) as titleCdLookup; trackBy:item?.lookupKey"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
            </nz-select>
            <nz-form-explain
              *ngIf="(captureClientDetailsForm.get('title').dirty || captureClientDetailsForm.get('title').touched) && captureClientDetailsForm.get('title').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('title'), CAPTURECLIENTDETAILSFORMNAME)">
                {{error || '' |translate}}</p>
            </nz-form-explain>
          </nz-form-control>
        </nz-form-item>

      </div> -->

      <nz-form-item>
        <nz-form-label nzFor="title" [nzSpan]="24" [nzRequired]="isRequired('title')">
          <span>{{genericSearchLabel.title[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="titleField" [nzSpan]="24">
          <nz-select nzShowSearch id="title" style="width: 100%" formControlName="title" (ngModelChange)="fieldOnChangeHandler('title')">
            <nz-option *ngFor="let item of (lookup$['titleCd'] | async) as titleCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('title').dirty || captureClientDetailsForm.get('title').touched) && captureClientDetailsForm.get('title').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('title'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('firstName')"><span
            translate>{{genericSearchLabel.firstName[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="firstNameField" [nzSpan]="24">
          <input nz-input placeholder="{{'First Name' | translate}}" formControlName="firstName" (ngModelChange)="fieldOnChangeHandler('firstName')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('firstName').dirty || captureClientDetailsForm.get('firstName').touched) && captureClientDetailsForm.get('firstName').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('firstName'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.middleName[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="middleNameField" [nzSpan]="24">
          <input nz-input placeholder="{{'Middle Name' | translate}}" formControlName="middleName" (ngModelChange)="fieldOnChangeHandler('middleName')"/>
          <!-- <nz-form-explain
          *ngIf="(captureClientDetailsForm.get('middleName').dirty || captureClientDetailsForm.get('middleName').touched) && captureClientDetailsForm.get('middleName').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('middleName'), CAPTURECLIENTDETAILSFORMNAME)">
            {{error|| '' |translate}}</p>
        </nz-form-explain> -->
        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('lastName')"><span
            translate>{{genericSearchLabel.lastName[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="lastNameField" [nzSpan]="24">
          <input nz-input placeholder="{{'Last Name' | translate}}" formControlName="lastName" (ngModelChange)="fieldOnChangeHandler('lastName')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('lastName').dirty || captureClientDetailsForm.get('lastName').touched) && captureClientDetailsForm.get('lastName').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('lastName'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>

      </nz-form-item>

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.employeeCode[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Employee Code" formControlName="employeeCode" />
        </nz-form-control>
      </nz-form-item> -->

      <nz-form-item>
        <nz-form-label nzFor="gender" [nzSpan]="24" [nzRequired]="isRequired('gender')"><span
            translate>{{genericSearchLabel.gender[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="genderField" [nzSpan]="24">
          <nz-select nzShowSearch id="gender" formControlName="gender" style="width: 100%" (ngModelChange)="fieldOnChangeHandler('gender')">
            <nz-option *ngFor="let item of (lookup$['genderCd'] | async) as genderCdCdLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <!--  -->
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('gender').dirty || captureClientDetailsForm.get('gender').touched) && captureClientDetailsForm.get('gender').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('gender'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('dateOfBirth')"><span
            translate>{{genericSearchLabel.dateOfBirth[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="dobField" [nzSpan]="24">
          <nz-date-picker id="dateOfBirth" formControlName="dateOfBirth" style="width:100%"
            [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR" (ngModelChange)="fieldOnChangeHandler('dateOfBirth')"></nz-date-picker>
          <!--  -->
          <!-- <nz-form-explain
          *ngIf="(captureClientDetailsForm.get('dateOfBirth').dirty || captureClientDetailsForm.get('dateOfBirth').touched) && captureClientDetailsForm.get('dateOfBirth').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(claimsBasicDetailsForm.get('dateOfBirth'), CAPTURECLIENTDETAILSFORMNAME)">
            {{error || '' |translate}}</p>
        </nz-form-explain> -->
        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('nationality')"><span
            translate>{{genericSearchLabel.nationality[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="nationalityField" [nzSpan]="24">
          <!-- <input nz-input placeholder="{{'Nationality' | translate}}" formControlName="nationality" /> -->
          <nz-select nzShowSearch style="width: 100%" formControlName="nationality" (ngModelChange)="fieldOnChangeHandler('nationality')">
            <nz-option
              *ngFor="let item of (lookup$['citizenshipCd'] | async) as nationalityLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('nationality').dirty || captureClientDetailsForm.get('nationality').touched) && captureClientDetailsForm.get('nationality').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('nationality'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error.errorMessage || '' |translate}}</p>
          </nz-form-explain>

        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('maritalStatus')"><span
            translate>{{genericSearchLabel.maritalStatus[currentLanguage]}}</span>
        </nz-form-label>
        <nz-select nzShowSearch id="maritalStatusCd" formControlName="maritalStatus" style="width: 100%" (ngModelChange)="fieldOnChangeHandler('maritalStatus')">
          <nz-option
            *ngFor="let item of (lookup$['maritalStatusCd'] | async) as maritalStatusLookup; trackBy:item?.lookupKey"
            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
        </nz-select>

        <nz-form-explain
          *ngIf="(captureClientDetailsForm.get('maritalStatus').dirty || captureClientDetailsForm.get('maritalStatus').touched) && captureClientDetailsForm.get('maritalStatus').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('maritalStatus'), CAPTURECLIENTDETAILSFORMNAME)">
            {{error.errorMessage || '' |translate}}</p>
        </nz-form-explain>

      </nz-form-item>

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>Nominee Relationship</span></nz-form-label>
        <nz-select nzShowSearch id="relationCd" formControlName="relationCd" style="width: 100%">
          <nz-option *ngFor="let item of (lookup$.relationCd | async) as relationCd; trackBy:item?.lookupKey"
            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
        </nz-select>
    </nz-form-item> -->

      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('occupationCd')"><span
            translate>{{genericSearchLabel.occupation[currentLanguage]}}</span>
        </nz-form-label>
        <nz-select nzShowSearch id="occupationCd" formControlName="occupationCd" style="width: 100%" (ngModelChange)="fieldOnChangeHandler('occupationCd')">
          <nz-option *ngFor="let item of (lookup$['occupationCd'] | async) as occupationCd; trackBy:item?.lookupKey"
            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.highestQualification[currentLanguage]}}</span>
        </nz-form-label>
        <nz-select nzShowSearch id="educationTypeCd" formControlName="educationTypeCd" style="width: 100%" (ngModelChange)="fieldOnChangeHandler('educationTypeCd')">
          <nz-option *ngFor="let item of (lookup$['educationCd'] | async) as educationLookup; trackBy:item?.lookupKey"
            [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
        </nz-select>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.sourceOfIncome[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="sourceOfIncomeField" [nzSpan]="24">
          <!-- <input nz-input placeholder="{{'Nationality' | translate}}" formControlName="nationality" /> -->
          <nz-select nzShowSearch style="width: 100%" formControlName="sourceOfIncome"  (ngModelChange)="fieldOnChangeHandler('sourceOfIncome')">
            <nz-option
              *ngFor="let item of (lookup$['sourceOfIncomeCd'] | async) as sourceOfIncomeLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <!-- <nz-form-explain
          *ngIf="(captureClientDetailsForm.get('nationality').dirty || captureClientDetailsForm.get('nationality').touched) && captureClientDetailsForm.get('nationality').errors">
          <p style="color:red"
            *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('nationality'), CAPTURECLIENTDETAILSFORMNAME)">
            {{error || '' |translate}}</p>
        </nz-form-explain> -->

        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.incomeRange[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="incomeRangeField" [nzSpan]="24">
          <!-- <input nz-input placeholder="{{'Nationality' | translate}}" formControlName="nationality" /> -->
          <nz-select nzShowSearch style="width: 100%" formControlName="incomeRange" (ngModelChange)="fieldOnChangeHandler('incomeRange')">
            <nz-option
              *ngFor="let item of (lookup$['yearlyIncomeRangeCd'] | async) as incomeRangeLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <!-- <nz-form-explain
              *ngIf="(captureClientDetailsForm.get('nationality').dirty || captureClientDetailsForm.get('nationality').touched) && captureClientDetailsForm.get('nationality').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('nationality'), CAPTURECLIENTDETAILSFORMNAME)">
                {{error || '' |translate}}</p>
            </nz-form-explain> -->

        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzFor="annualIncome"><span translate>{{genericSearchLabel.annualIncome[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="annualIncome" [nzSpan]="24" nzErrorTip="The input is not valid income">
          <!-- <input nz-input placeholder="Weight" formControlName="weight"/> -->
          <!-- <nz-input-number formControlName="weight" nzPlaceHolder ="Weight" [nzMin]="1" [nzMax]="700" [nzStep]="1" style="width:100%;"></nz-input-number>  -->
          <input type="text" placeholder="{{'Annual Income' | translate}}" nz-input formControlName="annualIncome" 
          oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');" (ngModelChange)="fieldOnChangeHandler('annualIncome')"/>
        </nz-form-control>
      </nz-form-item>
      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.UID[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="UID" formControlName="UID" />
        </nz-form-control>
      </nz-form-item> -->

      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired nzFor="weight"><span translate>{{genericSearchLabel.weight[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="weightField" [nzSpan]="24" nzErrorTip="The input is not valid weight">
          <!-- <input nz-input placeholder="Weight" formControlName="weight"/> -->
          <!-- <nz-input-number formControlName="weight" nzPlaceHolder ="Weight" [nzMin]="1" [nzMax]="700" [nzStep]="1" style="width:100%;"></nz-input-number>  -->
          <input type="text" placeholder="{{'Weight' | translate}}" nz-input formControlName="weight" 
          oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');" (ngModelChange)="fieldOnChangeHandler('weight')"/>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired nzFor="height"><span translate>{{genericSearchLabel.height[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="heightField" [nzSpan]="24">
          <!-- <input nz-input placeholder="Height" formControlName="height" /> -->
          <!-- <nz-input-number formControlName="height" nzPlaceHolder ="Height" [nzMin]="1" [nzMax]="300" [nzStep]="1" style="width:100%;" [nzRequired]="isRequired('height')"></nz-input-number> -->
          <input type="text" placeholder="{{'Height' | translate}}" nz-input formControlName="height"
          oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');"  (ngModelChange)="fieldOnChangeHandler('height')"/> 
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired nzFor="bmi"><span translate>{{genericSearchLabel.bmi[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="bmi" [nzSpan]="24">
          <!-- <input nz-input placeholder="Height" formControlName="height" /> -->
          <!-- <nz-input-number formControlName="height" nzPlaceHolder ="Height" [nzMin]="1" [nzMax]="300" [nzStep]="1" style="width:100%;" [nzRequired]="isRequired('height')"></nz-input-number> -->
          <input type="text" placeholder="{{'BMI' | translate}}" nz-input formControlName="bmi"
          oninput="this.value = this.value.replace(/[^0-9.]/g,'').replace(/(\..*?)\..*/g,'$1');"  (ngModelChange)="fieldOnChangeHandler('bmi')"/> 
        </nz-form-control>
      </nz-form-item>
      
      <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.haveCKYCNumber[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="haveCKYCNumberField" [nzSpan]="24">
          <nz-select nzShowSearch style="width: 100%" formControlName="haveCKYCNumber" (ngModelChange)="fieldOnChangeHandler('haveCKYCNumber')">
            <nz-option nzLabel="Yes" nzValue = "YES"></nz-option>
            <nz-option nzLabel="No" nzValue = "NO"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.CKYCNumber[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="CKYCNumberField" [nzSpan]="24">
          <input nz-input placeholder="CKYC Number" formControlName="CKYCNumber" (ngModelChange)="fieldOnChangeHandler('CKYCNumber')"/>
        </nz-form-control>
      </nz-form-item>

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.premiumPaymentZone[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select nzShowSearch style="width: 100%" formControlName="premiumPaymentZone">
            <nz-option nzLabel="Zone A" nzValue = "zone A"></nz-option>
            <nz-option nzLabel="Zone B" nzValue = "zone B"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item> -->

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.proposerRelation[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Relation with Proposer" formControlName="proposerRelation"/>
        </nz-form-control>
      </nz-form-item> -->

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.age[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Age" formControlName="age"/>
        </nz-form-control>
      </nz-form-item> -->

      
      <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.noOfChildren[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control id="noOfChildrenField" [nzSpan]="24">
          <!-- <input nz-input placeholder="No. Of Children" formControlName="noOfChildren" /> -->
          <nz-input-number formControlName="noOfChildren" [nzMin]="0" [nzStep]="1" style="width:100%;" (ngModelChange)="fieldOnChangeHandler('noOfChildren')"></nz-input-number>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="clientRole!='OWNER'">
        <nz-form-label [nzSpan]="24"><span
            translate>{{genericSearchLabel.relationshipWithPolicyHolder[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <!-- <input nz-input placeholder="{{'Nationality' | translate}}" formControlName="nationality" /> -->
          <nz-select nzShowSearch style="width: 100%" formControlName="relationCd" (ngModelChange)="fieldOnChangeHandler('relationCd')">
            <nz-option
              *ngFor="let item of (lookup$['relationCd'] | async) as relationshipLookup; trackBy:item?.lookupKey"
              [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
          <!-- <nz-form-explain
              *ngIf="(captureClientDetailsForm.get('nationality').dirty || captureClientDetailsForm.get('nationality').touched) && captureClientDetailsForm.get('nationality').errors">
              <p style="color:red"
                *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('nationality'), CAPTURECLIENTDETAILSFORMNAME)">
                {{error || '' |translate}}</p>
            </nz-form-explain> -->

        </nz-form-control>
      </nz-form-item>

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.sumInsured[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Sum Insured" formControlName="sumInsured"/>
        </nz-form-control>
      </nz-form-item> -->

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.nominee[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Nominee" formControlName="nominee"/>
        </nz-form-control>
      </nz-form-item> -->

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.nomineeRelation[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Nominee Relation" formControlName="nomineeRelation"/>
        </nz-form-control>
      </nz-form-item> -->

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.familyMonthlyIncome[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Family Monthly Income" formControlName="familyMonthlyIncome"/>
        </nz-form-control>
      </nz-form-item> -->

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.sumInsuredOptions[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Sum Insured Options" formControlName="sumInsuredOptions"/>
        </nz-form-control>
      </nz-form-item> -->

      <!-- <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.familyFloaterSumInsured[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="Family Floater Sum Insured" formControlName="familyFloaterSumInsured"/>
        </nz-form-control>
      </nz-form-item> -->

    </ng-container>

    <ng-container
      *ngIf="captureClientDetailsForm && (captureClientDetailsForm.get('clientTypeCd').value == 'ORGANISATION' || captureClientDetailsForm.get('clientTypeCd').value == 'ORGANIZATION')">
      <!-- companyName -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('companyName')"><span
            translate>{{genericSearchLabel.companyName[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="{{'Company Name' | translate}}" formControlName="companyName" (ngModelChange)="fieldOnChangeHandler('companyName')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('companyName').dirty || captureClientDetailsForm.get('companyName').touched) && captureClientDetailsForm.get('companyName').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('companyName'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>

      </nz-form-item>

      <!-- contactPersonName -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24" [nzRequired]="isRequired('contactPersonName')"><span
            translate>{{genericSearchLabel.contactPerson[currentLanguage]}}
            Name</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="{{'Contact Person Name' | translate}}" formControlName="contactPersonName" (ngModelChange)="fieldOnChangeHandler('contactPersonName')"/>
          <nz-form-explain
            *ngIf="(captureClientDetailsForm.get('contactPersonName').dirty || captureClientDetailsForm.get('contactPersonName').touched) && captureClientDetailsForm.get('contactPersonName').errors">
            <p style="color:red"
              *ngFor="let error of validationUtilService.getUIErrorList(captureClientDetailsForm.get('contactPersonName'), CAPTURECLIENTDETAILSFORMNAME)">
              {{error || '' |translate}}</p>
          </nz-form-explain>
        </nz-form-control>

      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24"><span translate>{{genericSearchLabel.gstNumber[currentLanguage]}}</span>
        </nz-form-label>
        <nz-form-control [nzSpan]="24">
          <input nz-input placeholder="GST Number" formControlName="gstNumber" />
        </nz-form-control>
      </nz-form-item>

    </ng-container>

    <!--TODO take review from Ninad  -->
    <input type="hidden" formControlName="clientid">
    <input type="hidden" formControlName="clientGuid">
    <input type="hidden" formControlName="statusCd">
    <input type="hidden" formControlName="clientNum">
    <input type="hidden" formControlName="personId">
    <input type="hidden" formControlName="personGuid">

    <!-- <nz-form-item>
      <nz-form-label [nzSpan]="24"><span translate>Source Of Evidence</span></nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input nz-input placeholder="{{'Source Of Evidence' | translate}}" formControlName="SOE" />
      </nz-form-control>
    </nz-form-item> -->





  </div>

  <div class="heading-tab">
    <h3 class="heading">
      <i nz-icon nzType="file-unknown" class="m-r-5"></i> <span translate>Contact Details</span></h3>
  </div>

  <div class="flexie-auto-grid">

    <!-- Email -->
    <div class="flex-self-vert-start">
      <h4>
        <i nz-icon nzType="mail" nzTheme="outline" class="m-r-5"></i> <span translate>Email</span></h4>
      <ui-multirow-basic (componentOutput)="fetchEmailList($event)" type="email"
        [inputDataForEdit]="inputClientCaptureEmailDetailsList"></ui-multirow-basic>
        <span>
          <label id="emailCheckbox" nz-checkbox formControlName="copyOfEmail">Do you wish to receive the copy of the policy document by Email /
            WhatsApp / Any other electronic mode</label>
        </span>
    </div>

    <!-- Mobile -->
    <div class="flex-self-vert-start">
      <h4>
        <i nz-icon nzType="mobile" nzTheme="outline" class="m-r-5"></i> <span translate>Mobile</span></h4>
      <ui-multirow-basic (componentOutput)="fetchphoneList($event)" type="phone"
        [inputDataForEdit]="inputClientCapturePhoneDetailsList"></ui-multirow-basic>
      <span>
        <label id="phoneCheckbox" nz-checkbox formControlName="contactByMobile">In case of any Offer, would you prefer to be contacted by Mobile Number</label>
      </span>
    </div>
  </div>
  <div>
    <ui-address-ind (componentOutput)="fetchAddressList($event)"
      [inputDataForEdit]="inputClientCaptureAddressDetailsList"></ui-address-ind>
  </div>
  <div *ngIf="false">
    <ui-address-thai (componentOutput)="fetchAddressList($event)"
      [inputDataForEdit]="inputClientCaptureAddressDetailsList"></ui-address-thai>
  </div>

  <app-identity-capture (componentOutput)="fetchIdentityList($event)"
    [inputDataForEdit]="inputClientCaptureIdentityDetailsList"></app-identity-capture>

  <!-- Document Manager: MINI mode (Must pass requirementCd && clientRefGuid: data is filtered based on these) -->
  <!-- <app-document-manager [mode]="'mini'" [requirementCd]="'NOMINEE_ACCOUNT'" [heading]="'Upload Identity Documents'">
  </app-document-manager> -->
  <!-- /Document Manager -->

  <!-- ID PROOFS -- >
  <div class="heading-tab">
    <h3 class="heading">
      <i nz-icon nzType="file-unknown"></i> ID Proofs</h3>
  </div>
  <!.-- Upload -- >
  <div class="d-b" style="min-height: 120px">
    <nz-upload nzAction="https://jsonplaceholderypicode.com/posts/" nzListType="picture-card"
      [(nzFileList)]="fileListIDProof" [nzShowButton]="fileListIDProof?.length < 2" [nzShowUploadList]="showUploadList"
      [nzPreview]="handlePreview">
      <i nz-icon nzType="plus"  nzTheme="outline"></i>
      <div class="ant-upload-text">Upload</div>
    </nz-upload>
    <nz-modal [nzVisible]="previewVisible" [nzContent]="modalContent" [nzFooter]="null"
      (nzOnCancel)="previewVisible = false">
      <ng-template #modalContent>
        <img [src]="previewImage" [ngStyle]="{ width: '100%' }" />
      </ng-template>
    </nz-modal>
  </div>
  <!.-- Verification Result -- >
  <div class="m-t-10">
    <h3 class="col-green d-b f-s-1-3r">
      <i nz-icon nzType="check" nzTheme="outline"></i> <span translate>Verified</span>
    </h3>
    <p>
      Account Number
      <b>40078977300</b> matches with OCR data in cheque image
    </p>
  </div>
  <!.-- -->



  <!-- <button nz-button nzType="primary" class="w-100-pc b-r-0" (click)="transformClient()"><i nz-icon nzType="safety"
      nzTheme="outline"></i> Transform</button> -->


</form>

<div class="footer-actions-bar">

  <div>
    <!-- Left -->
  </div>
  <div>
    <!-- Right -->
    <button nz-button [nzType]="'primary'" (click)="transformClient()"><span translate>Save</span></button>
  </div>
</div>
<!-- /add-customer-->